"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StaggeringBlowAbilityHandler = exports.StaggeringBlowActorAbilityFactory = exports.StaggeringBlowAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const Duration_1 = require("../../core/Duration");
const AbilityDamage_1 = require("../../core/AbilityDamage");
const core_1 = require("../../core/effects/core");
class StaggeringBlowAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.StaggeringBlow;
        this.__typeName = "StaggeringBlow";
    }
}
exports.StaggeringBlowAbilityArgs = StaggeringBlowAbilityArgs;
let StaggeringBlowActorAbilityFactory = class StaggeringBlowActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("StaggeringBlow", "OneEnemies", 2);
    }
};
StaggeringBlowActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("StaggeringBlow")
], StaggeringBlowActorAbilityFactory);
exports.StaggeringBlowActorAbilityFactory = StaggeringBlowActorAbilityFactory;
let StaggeringBlowAbilityHandler = class StaggeringBlowAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        const [selectedEnemy] = ability.args.target.actorIds;
        container.applyAttackWithDamage({
            sequence,
            abilityKey: ability.args.__typeName,
            attackType: "melee",
            attackerId: ability.invokerId,
            targetId: selectedEnemy,
            toApply: [
                AbilityDamage_1.AbilityDamage.Power("Physical", 120)
            ],
            onHit(sequence) {
                container.applyDebuff({
                    attackerId: ability.invokerId,
                    targetId: selectedEnemy,
                    effect: new core_1.VulnerabilityEffectArgs(5),
                    duration: Duration_1.Duration.Turns(5),
                    sequence: sequence.pushSequence("sequential"),
                });
            }
        });
    }
};
StaggeringBlowAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.StaggeringBlow)
], StaggeringBlowAbilityHandler);
exports.StaggeringBlowAbilityHandler = StaggeringBlowAbilityHandler;
